<template>
  <div
    id="footerddd"
    class="no-print"
  >
    <footer class="p-3 footer-color no-print">
      <div
        class="row"
        style="font-size: 14px;"
      >
        <div class="col-12 col-sm-6">
          <span>
            © 2019 高雄大學 National University of Kaohsiung<br>
            81148 高雄市楠梓區高雄大學路700號<br>
            700, Kaohsiung University Rd., Nanzih District, Kaohsiung 811, Taiwan, R.O.C.<br>
            教務處註冊組:07-5919038 傳真號碼:07-5919049
          </span>
        </div>
        <div class="col-12 col-sm-6">
          <a
            style="float:right;"
            href="javascript:location.href='https://ra.publicca.hinet.net/SSLQueryCert/SSLQueryCert.jsp?Domain_name='+document.location.hostname"
          >
            <img
              src="../../../public/img/SSLSeal.gif"
              width="90"
              height="126"
              alt="SSL"
            >
          </a>
          <a href="mailto:nukipay@nuk.edu.tw?subject=意見反映信箱：">
            意見反映信箱
          </a>
          <br>
          本網站所蒐集有關教職員生個人資訊，僅供教育行政使用，不另做其他用途。
          <br>最佳瀏覽建議使用Chrome、Firefox、Edge、Safari等瀏覽器。版本{{ Version }}
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      Version: window.g.Version
    }
  }
}
</script>

<style lang="scss">
  #footer{
    background: rgba(227, 227, 227, 0.5803921568627451);
    display: table;
    width: 100%;
    position: relative;
    height: 100px;
    margin-top: 18%;
  }
</style>
